module.exports = __webpack_public_path__ + "static/media/app_booking3.f6436f31.png";